import { ampli } from 'lib-shared-tracking';
import { useCallback, useState } from 'react';

import { flowsApi } from 'apis/flows';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import { NotificationType, useNotifications } from 'hooks/useNotifications';

import type { ScheduleModalProps } from '../../openingHours.view';

export const DeleteModal = ({
  schedule: { id, name },
  onClose,
  refetchItems,
}: ScheduleModalProps): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false);

  const [deleteSchedule] = flowsApi.useDeleteFlowScheduleMutation();
  const notify = useNotifications();

  const handleDelete = useCallback(async () => {
    ampli.businessHoursDeleteScheduleFormSubmitted();

    setIsLoading(true);

    const res = await deleteSchedule({ id });

    if ('data' in res) {
      notify(
        {
          title: `Schedule deleted!`,
          time: 5000,
        },
        NotificationType.Success,
      );
      refetchItems();
      onClose();
    } else {
      setIsLoading(false);
      notify(
        {
          title: `An error occurred when trying to delete "${name}" schedule.`,
        },
        NotificationType.Error,
      );
    }
  }, [deleteSchedule, id, name, notify, refetchItems, onClose]);

  return (
    <ConfirmModal
      isShown
      cancel={() => {
        onClose();
        ampli.businessHoursDeleteScheduleFormCancelled();
      }}
      confirm={handleDelete}
      confirmProps={{ isLoading }}
      confirmText="Delete"
      headline="Delete schedule?"
      text={`Are you sure you want to delete the schedule "${name}"? Please note that this action can't be undone.`}
    />
  );
};
